/**
 * Shared country names, authored once for the whole campaign scope.
 *
 * Metals' "Top mining countries" pills and articles' region labels both render the same
 * country names, so a single source of truth keeps them from drifting apart — a French
 * translator changes "Chile" here and every metal + article picks it up.
 *
 * Ids carry no metal or article slug, like `rm_section_*`: one string, translated once.
 */
export default {
  argentina: { id: 'rm_country_argentina', defaultMessage: 'Argentina' },
  australia: { id: 'rm_country_australia', defaultMessage: 'Australia' },
  belarus: { id: 'rm_country_belarus', defaultMessage: 'Belarus' },
  belgium: { id: 'rm_country_belgium', defaultMessage: 'Belgium' },
  bolivia: { id: 'rm_country_bolivia', defaultMessage: 'Bolivia' },
  brazil: { id: 'rm_country_brazil', defaultMessage: 'Brazil' },
  canada: { id: 'rm_country_canada', defaultMessage: 'Canada' },
  chile: { id: 'rm_country_chile', defaultMessage: 'Chile' },
  china: { id: 'rm_country_china', defaultMessage: 'China' },
  democraticRepublicCongo: {
    id: 'rm_country_democratic_republic_congo',
    defaultMessage: 'Democratic Republic of the Congo',
  },
  finland: { id: 'rm_country_finland', defaultMessage: 'Finland' },
  france: { id: 'rm_country_france', defaultMessage: 'France' },
  gabon: { id: 'rm_country_gabon', defaultMessage: 'Gabon' },
  germany: { id: 'rm_country_germany', defaultMessage: 'Germany' },
  ghana: { id: 'rm_country_ghana', defaultMessage: 'Ghana' },
  guinea: { id: 'rm_country_guinea', defaultMessage: 'Guinea' },
  india: { id: 'rm_country_india', defaultMessage: 'India' },
  indonesia: { id: 'rm_country_indonesia', defaultMessage: 'Indonesia' },
  iran: { id: 'rm_country_iran', defaultMessage: 'Iran' },
  israel: { id: 'rm_country_israel', defaultMessage: 'Israel' },
  japan: { id: 'rm_country_japan', defaultMessage: 'Japan' },
  kazakhstan: { id: 'rm_country_kazakhstan', defaultMessage: 'Kazakhstan' },
  madagascar: { id: 'rm_country_madagascar', defaultMessage: 'Madagascar' },
  mexico: { id: 'rm_country_mexico', defaultMessage: 'Mexico' },
  morocco: { id: 'rm_country_morocco', defaultMessage: 'Morocco' },
  mozambique: { id: 'rm_country_mozambique', defaultMessage: 'Mozambique' },
  myanmar: { id: 'rm_country_myanmar', defaultMessage: 'Myanmar' },
  namibia: { id: 'rm_country_namibia', defaultMessage: 'Namibia' },
  newCaledonia: {
    id: 'rm_country_new_caledonia',
    defaultMessage: 'New Caledonia',
  },
  nigeria: { id: 'rm_country_nigeria', defaultMessage: 'Nigeria' },
  northKorea: { id: 'rm_country_north_korea', defaultMessage: 'North Korea' },
  norway: { id: 'rm_country_norway', defaultMessage: 'Norway' },
  peru: { id: 'rm_country_peru', defaultMessage: 'Peru' },
  philippines: { id: 'rm_country_philippines', defaultMessage: 'Philippines' },
  poland: { id: 'rm_country_poland', defaultMessage: 'Poland' },
  russia: { id: 'rm_country_russia', defaultMessage: 'Russia' },
  rwanda: { id: 'rm_country_rwanda', defaultMessage: 'Rwanda' },
  senegal: { id: 'rm_country_senegal', defaultMessage: 'Senegal' },
  southAfrica: {
    id: 'rm_country_south_africa',
    defaultMessage: 'South Africa',
  },
  southKorea: { id: 'rm_country_south_korea', defaultMessage: 'South Korea' },
  spain: { id: 'rm_country_spain', defaultMessage: 'Spain' },
  tajikistan: { id: 'rm_country_tajikistan', defaultMessage: 'Tajikistan' },
  turkey: { id: 'rm_country_turkey', defaultMessage: 'Turkey' },
  ukraine: { id: 'rm_country_ukraine', defaultMessage: 'Ukraine' },
  unitedStates: {
    id: 'rm_country_united_states',
    defaultMessage: 'United States',
  },
  vietnam: { id: 'rm_country_vietnam', defaultMessage: 'Vietnam' },
  zimbabwe: { id: 'rm_country_zimbabwe', defaultMessage: 'Zimbabwe' },
} as const
